import { InputAdornment, Paper } from '@mui/material';

import React from 'react';
import { useFormContext } from 'react-hook-form';
import { LbInput, TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './WaterSetupBlock.module.scss';
import { Nutrient } from '../../../../../../../shared/components/ui-components';
import { MacroPlanStepFromValue } from '../../MacroPlanStep.settings';
import { validateNegativeNumber } from '../../../../../../../shared/utils/reactHookFormUtils';

type WaterSetupBlockProps = {
  nameIndex: number;
};

const WaterSetupBlock = ({ nameIndex }: WaterSetupBlockProps) => {
  const { control } = useFormContext<MacroPlanStepFromValue>();

  return (
    <Paper variant="roundedBox" className={classes.box}>
      <TitleWithDescription
        title="Water per day (oz)"
        description={
          <span>
            The standard water consumption is approx 0.5 oz per 1 lbs of body weight, but
            it can vary based on factors like exercise and propensity to sweat.
            <br />
            <br /> Check urine color to gauge hydration. Dark urine means more water is
            needed.
          </span>
        }
        titleFont="body-14-bold"
      />
      <LbInput
        control={control}
        name={`mealPlans.${nameIndex}.totalWater`}
        size="small"
        type="number"
        rules={{ validate: { validateNegativeNumber } }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Nutrient nutrient="water" />
            </InputAdornment>
          ),
        }}
      />
    </Paper>
  );
};

export { WaterSetupBlock };
